export default "__VITE_ASSET__B$TjQqTU__"